import React, { useRef } from 'react';
import { Chip, Button, Box } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function VideoFileInput({ file, onChange, disabled }) {
  const inputRef = useRef(null);
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

  const handleChange = (e) => {
    const selected = e.target.files[0];
    if (selected) onChange(selected);
  };

  const handleClear = () => {
    inputRef.current.value = '';
    onChange(null);
  };

  const fileSizeMB = file ? (() => {
    const mb = file.size / (1024 * 1024);
    return (mb >= 10 ? Math.round(mb) : mb.toFixed(1)) + ' MB';
  })() : null;

  const truncateFilename = (name, maxChars) => {
    const dot = name.lastIndexOf('.');
    const base = dot !== -1 ? name.slice(0, dot) : name;
    const ext = dot !== -1 ? name.slice(dot) : '';
    return base.length > maxChars ? `${base.slice(0, maxChars)}..${ext}` : name;
  };

  return (
    <>
      <input type="file" onChange={handleChange} accept="video/*" ref={inputRef} hidden />
      <Box display="flex" alignItems="center" gap={1}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<FileUploadOutlinedIcon />}
          type={file ? 'submit' : 'button'}
          onClick={file ? undefined : () => inputRef.current.click()}
          size="large"
          disabled={disabled}
          sx={{ flex: { xs: 1, md: 'none' }, minWidth: { xs: '25%', md: 'auto' }, whiteSpace: 'nowrap', textTransform: 'none' }}
        >
          {file ? (
            <>
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Upload video</Box>
              <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>Upload</Box>
            </>
          ) : 'Choose video'}
        </Button>
        {file && (
          <Chip
            label={`${truncateFilename(file.name, isDesktop ? 15 : 8)} • ${fileSizeMB}`}
            onDelete={handleClear}
            variant="outlined"
            color="primary"
            sx={{ minWidth: 0, height: 40, fontSize: '0.9375rem', '& .MuiChip-deleteIcon': { fontSize: 20 } }}
          />
        )}
      </Box>
    </>
  );
}
